export function normalizedQuery(value: string): string {
  return value.trim().toLowerCase();
}

export function includesQuery(value: string | null | undefined, query: string): boolean {
  return value?.toLowerCase().includes(query) ?? false;
}
